import PropTypes from 'prop-types';

import { CurrencyPropType } from './currency';

export const RatePropType = PropTypes.shape({
  shippingCost: CurrencyPropType,
  insuranceCost: CurrencyPropType,
  confirmationCost: CurrencyPropType,
  otherCost: CurrencyPropType,
  totalCost: CurrencyPropType,
});

/**
 * @typedef {object} RatePropType
 * @property {CurrencyPropType} shippingCost
 * @property {CurrencyPropType} insuranceCost
 * @property {CurrencyPropType} confirmationCost
 * @property {CurrencyPropType} otherCost
 * @property {CurrencyPropType} totalCost
 */
